import {faArrowUpRightFromSquare} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {NavGroupProps} from '@minimal/components/nav-section';
import {getLinkByEnv, LinkType} from '@workspaces/link';

const externalLinks: Record<string, LinkType> = {
  bdese: {
    PROD: 'https://app.bdes-online.fr/admin/',
    PREPROD: 'https://app-preprod.bdes-online.fr/admin/',
    DEV: 'https://app-preprod.bdes-online.fr/admin/',
    LOCAL: 'https://bdese.tissot-local.com/admin/',
  },
  boutique: {
    PROD: 'https://www.editions-tissot.fr/tissot-administration',
    PREPROD: 'https://www-preprod.editions-tissot.fr/tissot-administration',
    DEV: 'https://www-preprod.editions-tissot.fr/tissot-administration',
    LOCAL: 'https://boutique.tissot-local.com/',
  },
  cherami: {
    PROD: 'https://cherami.editions-tissot.fr/admin/login',
    PREPROD: 'https://cherami-preprod.editions-tissot.fr/admin/login',
    DEV: 'https://cherami-preprod.editions-tissot.fr/admin/login',
    LOCAL: 'https://cherami.tissot-local.com/admin/login',
  },
  cms_tissot: {
    PROD: 'https://tissot-cms.editions-tissot.fr/default.aspx',
    PREPROD: 'https://tissot-cms-preprod.editions-tissot.fr/default.aspx',
    DEV: 'https://tissot-cms-preprod.editions-tissot.fr/default.aspx',
    LOCAL: 'https://tissot-cms.tissot-local.com/default.aspx',
  },
  lumio_sam: {
    PROD: 'https://bop.lumio-rh.fr/admin/',
    PREPROD: 'https://bop-preprod.lumio-rh.fr/admin/',
    DEV: 'https://bop-preprod.lumio-rh.fr/admin/',
    LOCAL: 'https://lumio-bop.tissot-local.com/admin/',
  },
  lumio_sauron: {
    PROD: 'https://back-office.lumio-rh.fr/home',
    PREPROD: 'https://back-office-preprod.lumio-rh.fr/home',
    DEV: 'https://back-office-preprod.lumio-rh.fr/home',
    LOCAL: 'https://lumio-sauron.tissot-local.com/home',
  },
  nemesis: {
    PROD: 'https://nemesis.editions-tissot.fr/',
    PREPROD: 'https://nemesis-preprod.editions-tissot.fr/',
    DEV: 'https://nemesis-dev.editions-tissot.fr/',
    LOCAL: 'https://nemesis-api.tissot-local.com/',
  },
  otis: {
    PROD: 'https://otis.editions-tissot.fr/otis-admin/login',
    PREPROD: 'https://otis-preprod.editions-tissot.fr/otis-admin/login',
    DEV: 'https://otis-preprod.editions-tissot.fr/otis-admin/login',
    LOCAL: 'https://localhost:3000/otis-admin/login',
  },
  ouvrage_factory: {
    PROD: 'https://www.editions-tissot.fr/doc/admin/login',
    PREPROD: 'https://www-preprod.editions-tissot.fr/doc/admin/login',
    DEV: 'https://www-preprod.editions-tissot.fr/doc/admin/login',
    LOCAL: 'https://localhost:3000/doc/admin/login',
  },
  simulateur: {
    PROD: 'https://simulateur.editions-tissot.fr/admin/calculateurs',
    PREPROD: 'https://simulateur-preprod.editions-tissot.fr/admin/calculateurs',
    DEV: 'https://simulateur-dev.editions-tissot.fr/admin/calculateurs',
    LOCAL: 'https://simulateur.tissot-local.com/admin/calculateurs',
  },
  sylius: {
    PROD: 'https://shop.editions-tissot.fr/admin/',
    PREPROD: 'https://shop-preprod.editions-tissot.fr/admin/',
    DEV: 'https://shop-preprod.editions-tissot.fr/admin/',
    LOCAL: 'https://shop.tissot-local.com/',
  },
  webactu: {
    PROD: 'https://www.editions-tissot.fr/actualite/admin/login',
    PREPROD: 'https://webactu-preprod.editions-tissot.fr/actualite/admin/login',
    DEV: 'https://webactu-preprod.editions-tissot.fr/actualite/admin/login',
    LOCAL: 'https://webactu.tissot-local.com/actualite/admin/login',
  },
};

export const menu: NavGroupProps[] = [
  {
    subheader: 'menu.external.title',
    items: [
      {
        title: 'menu.external.bdese',
        path: getLinkByEnv(externalLinks.bdese),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.boutique',
        path: getLinkByEnv(externalLinks.boutique),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.cherami',
        path: getLinkByEnv(externalLinks.cherami),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.lumio_sauron',
        path: getLinkByEnv(externalLinks.lumio_sauron),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.lumio_sam',
        path: getLinkByEnv(externalLinks.lumio_sam),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.nemesis',
        path: getLinkByEnv(externalLinks.nemesis),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.sylius',
        path: getLinkByEnv(externalLinks.sylius),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.simulateur',
        path: getLinkByEnv(externalLinks.simulateur),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.cms_tissot',
        path: getLinkByEnv(externalLinks.cms_tissot),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.otis',
        path: getLinkByEnv(externalLinks.otis),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.ouvrage_factory',
        path: getLinkByEnv(externalLinks.ouvrage_factory),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
      {
        title: 'menu.external.webactu',
        path: getLinkByEnv(externalLinks.webactu),
        icon: <FontAwesomeIcon icon={faArrowUpRightFromSquare} />,
      },
    ],
  },
];
